
interface ProfileBioProps {
  bio: string | null;
}

export const ProfileBio = ({ bio }: ProfileBioProps) => {
  if (!bio || bio.trim() === '') {
    return (
      <div className="text-center py-6 px-4 bg-gray-50 rounded-lg border border-dashed border-gray-200">
        <p className="text-gray-600">Add a bio to tell hosts and fellow travelers about yourself</p>
        <p className="text-gray-500 text-sm mt-2">Share your travel style, interests, and experiences</p>
      </div>
    );
  }

  return (
    <div className="space-y-2">
      <h3 className="font-semibold mb-3 text-gray-800">About</h3>
      <div className="text-gray-700 leading-relaxed whitespace-pre-wrap">
        {bio.split('\n').map((paragraph, index) => (
          <p key={index} className={index > 0 ? "mt-3" : ""}>
            {paragraph}
          </p>
        ))}
      </div>
    </div>
  );
};
